/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedBurnRatioDtoSchema } from "./investmentNeedBurnRatioDtoSchema.ts";
import { investmentNeedFundingHistoryDtoSchema } from "./investmentNeedFundingHistoryDtoSchema.ts";
import { investmentNeedFundraisingStrategyDtoSchema } from "./investmentNeedFundraisingStrategyDtoSchema.ts";
import { investmentNeedOverviewDtoSchema } from "./investmentNeedOverviewDtoSchema.ts";
import { investmentNeedUseOfFundsDtoSchema } from "./investmentNeedUseOfFundsDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedSectionDtoSchema = z.object({
  get overview() {
    return investmentNeedOverviewDtoSchema.optional();
  },
  get useOfFunds() {
    return investmentNeedUseOfFundsDtoSchema.optional();
  },
  get fundingHistory() {
    return investmentNeedFundingHistoryDtoSchema.optional();
  },
  get fundraisingStrategy() {
    return investmentNeedFundraisingStrategyDtoSchema.optional();
  },
  get burnRatio() {
    return investmentNeedBurnRatioDtoSchema.optional();
  },
});
